export default __webpack_public_path__ + "static/media/neteller.6d735b5f.svg";